export const locale = {
    lang: 'pl',
    data: {
        "New": "Nowe",
        "Add template": "Dodaj szablon",
        "Orders history": "Historia zamówień",
        "Add position": "Dodaj pozycję",
        "Product": "Produkt",
        "Unit": "Jednostka",
        "Quantity": "Ilość",
        "Price net": "Cena netto",
        "Price gross": "Cena brutto",
        "Remove": "Usuń",
        "Sale voucher": "Sprzedaj karnet",
        "Voucher sale": "Sprzedaż karnetów",
        "Products sale": "Sprzedaż produktów",
        "Worker": "Pracownik",
        "Description": "Opis",
        "Customer": "Klient",
        "Save": "Zapisz",
        "Vat rate": "VAT",
        "Voucher": "Karnet",
        "Dedication": "Dedykacja",
        "Owner": "Właściciel",
        "Price": "Wartość",
        "Created at": "Data dodania",
        "Actions": "Akcje",
        "Details": "Szczegóły",
        "Name": "Nazwa",
        "Document date": "Data dokumentu",
        "Positions": "Pozycje",
        "Payment method": "Metoda płatności",
        "Create invoice": "Utwórz fakturę",
        "Street": "Ulica",
        "Country": "Kraj",
        "Post code": "Kod pocztowy",
        "City": "Miasto",
        "Line value": "Wartość linii",
        "Order Details": "Szczegóły zamówienia",
        "Products": "Produkty",
        "Invoice": "Faktura",
        "PRODUCT": "PRODUKT",
        "INVOICE": "FAKTURA",
        "PRICE": "CENA",
        "QUANTITY": "ILOŚĆ",
        "TOTAL": "WARTOŚĆ",
        "Phone": "Telefon",
        "Company": "Firma",
        "Printed at": "Data wydrukowania",
        "Read by printer": "Odczytana przez drukarkę",
        "Printed": "Wydrukowana",
        "Yes": "Tak",
        "No": "Nie",
        "Order": "Zamówienie",
        "Add action": "Dodaj akcję",
        "Action key": "Klucz akcji",
        "Is active": "Czy aktywna",
        "Created by": "Dodał",
        "Edit": "Edycja",
        "Service": "Usługa",
        "Add item": "Dodaj usługę",
        "Action data": "Dane akcji",
        "Validity time": "Czas ważności",
        "Delete": "Usuń",
        "Add public API access key": "Dodaj klucz",
        "Access key": "Klucz dostępowy",
        "Public API access data": "Dane klucza dostępu do publicznego API",
        "Are you sure you want to delete selected public API access key?": "Czy na pewno chcesz usunąć wybrany klucz dostępu do API publicznego?",
        "Message templates": "Szablony wiadomości",
        "Message template data": "Dane szablonu wiadomości",
        "Name is required!": "Nazwa jest wymagana!",
        "Description is required!": "Opis jest wymagany!",
        "Notification account": "Konto powiadomień",
        "Customer registration message": "Wiadomość rejestracji klienta",
        "Customer confirm message": "Wiadomość potwierdzenia klienta",
        "Order payment started message": "Wiadomość rozpoczęcia płatności zamówienia",
        "Order paid message": "Wiadomość opłaconego zamówienia",
        "Order payment error message": "Wiadomość błędu płatności zamówienia",
        "Order assigned to card message": "Wiadomość przypisania zamówienia do karty",
        "Impossible to assign order to card message": "Wiadomość niemożności przypisania zamówienia do karty",
        "Reset password message": "Wiadomość resetowania hasła",
        "Delete account message": "Wiadomość usunięcia konta",
        "Temporary password message": "Wiadomość hasła tymczasowego",
        "Test it!": "Testuj!",
        "Message template added successfully": "Szablon wiadomości został dodany",
        "Message template creation error": "Błąd tworzenia szablonu wiadomości",
        "Update successful": "Aktualizacja zakończona sukcesem",
        "Message template update error": "Błąd aktualizacji szablonu wiadomości",
        "Test successful": "Test zakończony sukcesem",
        "Test error": "Błąd testu",
        "Mobile app": "Aplikacja mobilna"
    }
};
